<template>
    <div class="text-center mx-auto" style="height: 80vh; max-height: 80vh; max-width: 80vw;">
        <video ref="player" class="mx-auto video-js vjs-default-skin vjs-big-play-centered"></video>
    </div>
</template>

<script>

import videojs from 'video.js';

export default {
    name: 'VideoComponent',
    props: {
        options: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            player: null,
            defaultOpts: {
                autoplay: false,
                controls: true,
                responsive: true,
                // responsive: false,
                html5: {
                    hls: {
                        overrideNative: true,
                    },
                },
                // fluid: true,
                fill: true,
                // videoHeight: 360,
                // videoWidth: 480,
                // aspectRatio: '16:9',
                // aspectRatio: '9:16',
            },
        };
    },
    mounted() {
        this.player = videojs(this.$refs.player, _.merge(this.options, this.defaultOpts), () => {
        });
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose();
        }
    },
};

</script>

<style>
/*.vjs-tech {
    object-fit: unset;
}*/

/*.vjs_video_450-dimensions.vjs-fluid {
    padding-top: 75vh;
}*/
</style>
